import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Helmet } from 'react-helmet-async';
import { useParams, withRouter } from 'react-router-dom';
import { getPageTypeBySlug } from 'lib/contentful-client';
import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import Nav from './components/Nav/Nav';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
const BlogHome = loadable(() => import('./BlogHome'));
const BlogCategory = loadable(() => import('./BlogCategory'));
const SinglePost = loadable(() => import('./SinglePost'));
const Home = t0 => {
  const $ = _c(30);
  const {
    match,
    history,
    staticContext,
    isAdmin
  } = t0;
  const params = useParams();
  const slug = !params.slug ? "" : params.slug;
  let t1;
  if ($[0] !== match.url) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /\/$/;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = match.url.split("/")[1].replace(t2, "");
    $[0] = match.url;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const blogUrl = `${t1}/`;
  let t2;
  if ($[3] !== slug) {
    t2 = !slug ? "home" : getPageTypeBySlug(slug);
    $[3] = slug;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const currentPage = t2;
  if (isAdmin) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <AdminPlaceholder>JB Contentful API Blog Component Placeholder for Variant Builder. <br />The component will display correctly in Consumer</AdminPlaceholder>;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Helmet><title>Joybird | A Design Blog by Joybird</title><meta name="description" content="A blog about interior design, home decor inspiration and more. Express yourself through your space." /><meta property="og:title" content={"Canvas \u2014 A Blog by Joybird"} /><meta property="og:description" content="A blog about interior design, home decor inspiration and more. Express yourself through your space." /><meta property="og:type" content="website" /></Helmet>;
    t4 = <ScrollToTop />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== blogUrl || $[9] !== slug) {
    t5 = <Nav blogUrl={blogUrl} slug={slug} />;
    $[8] = blogUrl;
    $[9] = slug;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== blogUrl || $[12] !== currentPage || $[13] !== slug) {
    t6 = currentPage === "home" && <BlogHome slug={slug} blogUrl={blogUrl} />;
    $[11] = blogUrl;
    $[12] = currentPage;
    $[13] = slug;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== blogUrl || $[16] !== currentPage || $[17] !== slug) {
    t7 = currentPage === "category" && <BlogCategory blogUrl={blogUrl} slug={slug} />;
    $[15] = blogUrl;
    $[16] = currentPage;
    $[17] = slug;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== blogUrl || $[20] !== currentPage || $[21] !== history || $[22] !== slug || $[23] !== staticContext) {
    t8 = currentPage === "single" && <SinglePost blogUrl={blogUrl} slug={slug} history={history} staticContext={staticContext} />;
    $[19] = blogUrl;
    $[20] = currentPage;
    $[21] = history;
    $[22] = slug;
    $[23] = staticContext;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
    t9 = <div className="[&_a]:no-underline">{t3}{t4}{t5}{t6}{t7}{t8}</div>;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
};
Home.propTypes = {
  match: PropTypes.objectOf(PropTypes.object),
  history: PropTypes.objectOf(PropTypes.object),
  staticContext: PropTypes.objectOf(PropTypes.object),
  isAdmin: PropTypes.bool
};
export default withRouter(Home);